export const localeFr = {
    'welcome-title': 'Bienvenue sur MYEFFICIENCY !',
    'welcome-description': "L'outil de diagnostic par",
    'welcome-choose-store': "Commence par selectionner ton magasin...",
    'loading-diagnoses': 'Chargement des diagnostics...',
    add: 'Ajouter',
    associate: 'Associer',
    confirm: 'Valider',
    return: 'Retour',
    cancel: 'Annuler',
    dissociate: 'Dissocier',
    'dissociate-sub-theme': 'Dissocier le sous-thème',
    'edit-sub-theme': 'Éditer le sous-thème',
    select: 'Sélectionner',
    diagnostic: 'Diagnostic',
    tips: 'FAQ / Conseils',
    data: ' Data associées',
    illustrations: 'Illustrations',
    'complementary-questions-title': 'Pour aller plus loin',
    'additional-data': {
        desktop: "Plus d'infos",
        mobile: 'Infos'
    },
    'kpi-region': 'KPI région',
    'satisfaction-by-theme': 'Conformité / thèmes',
    'satisfaction-by-sub-theme': 'Conformité / sous-thèmes',
    'not-applicable-by-theme': 'Non applicable / thèmes',
    'not-applicable-by-sub-theme': 'Non applicable / sous-thèmes',
    'to-do': 'à faire',
    country: 'Pays',
    yes: {
        desktop: 'Oui',
        mobile: 'Oui'
    },
    no: {
        desktop: 'Non',
        mobile: 'Non'
    },
    nc: {
        desktop: 'Non applicable',
        mobile: 'N/A'
    },
    high: 'Haute',
    medium: 'Moyenne',
    low: 'Faible',
    all: 'Tous',
    priority: 'Priorités',
    'to-be-processed': "À traiter",
    'in-progress': "Engagée",
    completed: "Terminée",
    'dissociate-question': 'Dissocier une question',
    'edit-question': 'Modifier une question',
    'delete-question': 'Supprimer une question',
    store: 'Magasin',
    my_store: 'Mon magasin',
    diagnostics: 'Diagnostics',
    themes: 'Themes',
    subThemes: 'Sous-thèmes',
    questions: 'Questions',
    actions: 'Actions',
    actionCount: 'Actions',
    icons: 'Icones',
    delete: 'Supprimer',
    edit: 'Modifier',
    save: 'Enregistrer',
    required: 'Champs obligatoire',
    'min-char': 'Min 3 caractères',
    draft: 'Brouillon',
    enabled: 'Actif | Actifs',
    disabled: 'Inactif | Inactifs',
    archived: 'Archivé | Archivés',
    languages: 'Langues',
    status: 'Statut',
    edited: 'Édités',
    availability: 'Disponibilité',
    retry: 'Actualiser',
    label : 'Libellé',
    title : 'Titre',
    link : 'Lien',
    search: 'Chercher',
    "not-url" :"Veuillez entrer une URL valide.",
    error: {
        "kpi-failed": 'Impossible de charger {kpiLabel}'
    },
    'questions-per-page': 'Questions par page',
    perimeter: 'Périmètre',
    completion: 'Remplissage',
    satisfaction: 'Conformité',
    "not-applicable": 'Non applicable',
    store_count: 'Nb Magasin',
    active_store_count: 'Nb Magasin actif',
    salesArea: 'M²',
    typology: 'Plan de masse',
    satisfaction_by_theme_region: 'Conformité par thèmes et region',
    satisfaction_by_sub_theme_region: 'Conformité par sous-thèmes et region',
    satisfaction_by_theme_store: 'Conformité par thèmes et magasin',
    satisfaction_by_sub_theme_store: 'Conformité par sous-thème et magasin',
    by_region: 'Par region',
    by_store: 'Par magasin',
    "admin-mode": 'Mode Admin',
    "quit-admin": 'Quitter Admin',
    logout: 'Déconnexion',
    "select-store": 'Sélectionne ton magasin',
    "select-diag": 'Sélectionne ton diagnostic',
    "select-language": 'Sélectionne ta langue',
    "global-satisfaction": 'Conformité globale',
    'add-photos' :'Ajouter des photos',
    'last-update': 'Dernière MAJ',
    'select-diagnosis': 'Selectionne un diagnostic ',
    last_update: 'mis à jour le {date}',
    involved_peoples: '{peoples}',
    last_update_and_user: 'mis à jour le {date} par {user}',
    create_on: 'crée le {date} by {user}',
    translations: 'Traductions',
    'archive-scope-question': 'A quelle niveau souhaites-tu réinitialiser le diagnostic en cours?',
    'answered-by': "Répondu par",
    'along-with': "Accompagné de",
    'switch-diag-store': {
        title: "Changement de diagnostic/magasin",
        text: "Une session avec un autre diagnostic et/ou un autre magasin existe déjà voulez-vous continuer? si OUI les changements suivant s'appliqueront :"
    },
    'restore-last-archive': {
        'tab-item': "Restaurer la dernière archive",
        text: "Tu confirmes vouloir restaurer la dernière archive et ainsi revenir a l'état du diagnostic précedent?",
        'success-msg': "Restauration effectué",
        'error-msg': "Erreur lors de la restauration"
    },
    archive: {
        'part-region': ' pour tous les magasins de ta region',
        'part-country': ' pour tous les magasins de ton pays',
        'part-world': ' pour tous les magasins United',
        warning: {
            'begin': 'Avec archivage, Le diagnostic sera archivé et réinitialisé immediatement',
            'end': ', tu pourras le retrouver dans le menu '
        },
        error: {
            'begin-1': 'SANS ARCHIVAGE',
            'begin-2': ", le diagnostic sera réinitialisé immediatement",
            end: " et toutes les données associées aux réponses seront perdues (photos, plans d'action,...)"
        },
        'success-msg': 'Réinitialisation effectuée avec succès',
        'error-msg': 'Erreur lors de la réinitialisation',
        'last-update': 'Pour les dernières MAJ avant le :'
    },
    'archive-with': 'Avec Archivage',
    'primary-diag': 'Diag prioritaire',
    'begin-diag': 'Démarrer mon diagnostic',
    'resume-diag': 'Continuer mon diagnostic',
    'custom-diag': 'Diagnotic sur-mesure',
    'alert-diag': 'Diagnotic / KPI',
    'archive-diag': 'Réinitialiser/Archiver...',
    'historic-diag': 'Historique des diagnostics',
    region: 'Ma région',
    'my-country': 'Mon Pays',
    world: 'United',
    'world-store-export': 'Exporter United (CSV)',
    'world-store-export-success': 'Export réalisé avec succès',
    'world-store-export-error': "Erreur lors de l'export",
    'photos-download': 'Télécharger les photos (ZIP)',
    'photos-download-success': 'Le téléchargement des photos va bientot commencer...',
    'photos-download-error': 'Erreur lors du téléchargement des photos',
    'action-plan': "Actions",
    'choose-theme': 'Séléctionne un thème',
    reporting: 'Reporting',
    'switch-diagnostic': 'Changer de diagnostic',
    'active-perimeter': "Perimètre actif",
    'active-stores': 'Mag. actifs',
    'apply-filters': 'Appliquer les filtres',
    'filter': 'Filtre',
    'store-type': 'Type de magasin',
    'store-category': 'Catégorie de magasin',
    'diagnostics-started': 'Remplissage > 0',
    'type': 'Type',
    'category': 'Catégorie',
    admin: {
        title: 'Administration',
        "no-theme-available": 'Aucun thème disponible',
        "no-sub-theme-available": 'Aucun sous-thème disponible',
        "no-question-available": 'Aucune question disponible',
        'add-diagnosis': 'NOUVEAU DIAGNOSTIC',
        'or': 'ou',
        'purge-diagnosis': 'Supprimer définitivement',
        'purge-diagnosis-confirm': 'Êtes-vous sûr de vouloir supprimer définitivement ce diagnostic ? Cette action est irréversible.',
        'purge-diagnosis-responses-warning': 'Attention : des réponses sont associées aux questions de ce diagnostic. Sa suppression entraînera également la suppression définitive de toutes ces réponses.',
        'purge-diagnosis-success': 'Diagnostic supprimé définitivement',
        'purge-diagnosis-error': 'Erreur lors de la suppression du diagnostic',
        'purge-theme': 'Supprimer définitivement',
        'purge-theme-confirm': 'Êtes-vous sûr de vouloir supprimer définitivement ce thème ? Cette action est irréversible.',
        'purge-theme-responses-warning': 'Attention : des réponses sont associées aux questions de ce thème. Sa suppression entraînera également la suppression définitive de toutes ces réponses.',
        'purge-theme-success': 'Thème supprimé définitivement',
        'purge-theme-error': 'Erreur lors de la suppression du thème',
        'purge-subtheme': 'Supprimer définitivement',
        'purge-subtheme-confirm': 'Êtes-vous sûr de vouloir supprimer définitivement ce sous-thème ? Cette action est irréversible.',
        'purge-subtheme-responses-warning': 'Attention : des réponses sont associées aux questions de ce sous-thème. Sa suppression entraînera également la suppression définitive de toutes ces réponses.',
        'purge-subtheme-success': 'Sous-thème supprimé définitivement',
        'purge-subtheme-error': 'Erreur lors de la suppression du sous-thème',
        'purge-question': 'Supprimer définitivement',
        'purge-question-confirm': 'Êtes-vous sûr de vouloir supprimer définitivement cette question ? Cette action est irréversible.',
        'purge-question-responses-warning': 'Attention : des réponses sont associées à cette question. Sa suppression entraînera également la suppression définitive de toutes ces réponses.',
        'purge-question-success': 'Question supprimée définitivement',
        'purge-question-error': 'Erreur lors de la suppression de la question',
        'import-diagnosis': 'IMPORTER UN DIAGNOSTIC',
        'import-diagnosis-success': 'Diagnostic importé avec succès',
        'import-diagnosis-error': "Échec de l'import du diagnostic",
        'import-diagnosis-invalid-file': 'Fichier invalide : sélectionnez un Google Sheet (.gsheet) depuis Google Drive',
        'import-diagnosis-invalid-url': "URL invalide : collez l'URL complète du Google Sheet",
        'import-diagnosis-manual': "Ou coller l'URL du Google Sheet",
        'import-diagnosis-title': 'Importer un diagnostic',
        'import-diagnosis-spreadsheet-url': 'URL du Google Sheet',
        'add-theme': 'Ajouter un thème',
        'add-sub-theme': 'Ajouter un sous-thème',
        'add-question': 'Ajouter une question',
        'add-link': 'Ajouter un lien',
        'add-photo': 'Ajouter une photo',
        "add-selected-sub-themes": "Ajouter le sous-theme selectionné | Ajouter les {count} sous-themes selectionnés",
        "add-selected-languages": "Ajouter la langue selectionnée | Ajouter les {count} langues selectionnées",
        "add-selected-questions": "Ajouter la question selectionnée | Ajouter les {count} questions selectionnées",
        "add-first-theme-message": 'Ajoute dès maintenant ton premier thème',
        "add-first-sub-theme-message": 'Ajoute dès maintenant ton premier sous-thème',
        "add-first-question-message": 'Ajoute dès maintenant ta première question',
        "associate-sub-themes-message": 'Associe un ou plusieurs sous-thème(s)',
        "associate-questions-message": 'Associe une ou plusieurs question(s)',
        "quit-page": "Quitter l’administration",
        position: 'Position',
        'new-diag': 'Configuration du NOUVEAU Diagnostic',
        'setup-diag': 'Configuration du Diagnostic',
        'setup-theme': 'Configuration du thème',
        'setup-sub-theme': 'Configuration du sous-thème',
        'setup-question': 'Configuration de la question',
        publish: 'Publier',
        'diag-available': 'Ce diagnostic sera disponible en :',
        'theme-available': 'Ce thème sera disponible en :',
        'sub-theme-available': 'Ce sous-thème sera disponible en :',
        'question-available': 'Cette question sera disponible en:',
        'diag-title': 'Intitulé du diagnostic',
        'theme-title': 'Intitulé du thème',
        'sub-theme-title': 'Intitulé du sous-thème',
        'question-title': 'Intitulé de la question',
        'theme-icon': 'Icône du thème',
        'associated-subthemes': 'Sous-thèmes associés',
        'dissociate-sub-theme': 'Dissocier le sous-thème',
        'associate-sub-theme': 'Associer un sous-thème',
        'associated-themes': 'Thèmes associés',
        'associate-theme': 'Associer un theme',
        'dissociate-theme': 'Dissocier le theme',
        local: 'Local',
        united: 'United',
        'certain-country': 'Certains pays',
        archive: 'Archiver',
        unarchive: 'Désarchiver',
        edit: 'Éditer',
        enable: 'Activer',
        disable: 'Désactiver',
        'diagnostic-enabled-united-themes-warning': 'Pour "Activer" le diagnostic en "United", au moins un theme doit être "United" et "Actif"',
        'diagnostic-enabled-themes-warning': 'Pour "Activer" le diagnostic, au moins une theme doit être "Actif"',
        'theme-english-translation-warning': 'Pour "Activer" le theme en "United", son intitulé doit être traduit en Anglais (EN).',
        'theme-enabled-united-subthemes-warning': 'Pour "Activer" le theme en "United", au moins un sous-theme doit être "United" et "Actif"',
        'theme-enabled-subthemes-warning': 'Pour "Activer" le theme, au moins une sous-theme doit être "Actif"',
        'subtheme-english-translation-warning': 'Pour "Activer" le sous-theme en "United", son intitulé doit être traduit en Anglais (EN).',
        'subtheme-enabled-united-questions-warning': 'Pour "Activer" le sous-theme en "United", au moins une question doit être "United" et "Actif"',
        'subtheme-enabled-questions-warning': 'Pour "Activer" le sous-theme, au moins une question doit être "Actif"',
        'question-english-translation-warning': 'Pour "Activer" la question en "United", son intitulé doit être traduit en Anglais (EN).',
        'subtheme-dissociation-title-dialog': 'Voulez vous dissocier le sous-thème "{label}" ?',
        'question-dissociation-title-dialog': 'Voulez vous dissocier la question "{label}" ?',
        'question-archive-title-dialog': 'Voulez vous archiver la question:"{label}" ?',
        'questions-archive-title-dialog': "Voulez vous confirmer l'archivage de la question sélectionnée ? |'Voulez vous confirmer l'archivage des {count} questions sélectionnées ?",
        perimeter: 'Périmètre',
        'all-countries': 'Tous les pays',
        'certain-countries': 'Certains pays uniquement',
        'involved-countries': 'Pays concernés',
        'status-menu-title': 'Voulez vous {status} "{label}" ?',
        'no-associated-theme': 'Aucun thème associé',
        'no-associated-sub-theme': 'Aucun sous-thème associé',
        'associated-theme': 'Thème associé',
        'associated-sub-theme': 'Sous-thème associé',
        resources: 'Ressources',
        "selected-questions": "{count} question selectionnée | {count} questions selectionné",
        success: {
            dissociate: 'La dissociation est faite avec succes',
            archive: "L'archivage est faite avec succes",
            "associate-and-dissociate": 'La dissociation et la nouvelle association est faite avec succes',
            associate: " L'association est faite avec succes,"
        },
        error: {
            dissociate: 'Une erreur est survenue lors de dissociation de la question',
            associate: 'Une erreur est survenue lors de dissociation de la question',
            "associate-and-dissociate": 'Une erreur est survenue',
            archive: "Une erreur est survenue lors de l'archivage de la question",
        },
        "resource-url": 'URL de la ressource',
        "edit-to-see-details": "Editer pour voir le detail des avertissements",
        "missing-translation": "-- traduction manquante --",
        "new-diagnostic": "Nouveau Diagnostic",
        "new-theme": "Nouveau theme",
        "new-sub-theme": "Nouveau sous-theme",
        "new-question": "Nouvelle question",
        "supported-languages": "Langues prises en charge",
        'edit-diag' : 'Configuration du diagnostic',
        'upload-photos' : "Télécharger des photos",
        'choose-photos' : "Choisir des photos",
        'select-language' : 'Sélectionner une langue...',
        'associated-kpis': 'Kpis associés',
        'associated-resources': 'Ressources associées',
        'move-to': 'Déplacer dans'
    }
}
